import React, { forwardRef } from 'react';
import Layout from '../../Layout';
import type { GridItemProps } from './types';

const GridItem = forwardRef<HTMLElement, GridItemProps>(({ children, ...restProps }: GridItemProps, ref) => (
  <Layout ref={ref} {...restProps}>
    {children}
  </Layout>
));

GridItem.displayName = 'GridItem';

export default GridItem;
